import Vue from 'vue'
import * as moment from 'moment';

import i18n from '../utilities/i18n';

const vueInstance = new Vue({
  i18n
});

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  let arr = value.split(" ")
  let capitalized_array = []
  arr.forEach((word) => {
    let capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(" ");
})

Vue.filter('truncate', function (value, limit) {
  return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
  return value + tail;
})

Vue.filter('time', function (value, is24HrFormat = true) {
  if (value) {
    if (is24HrFormat) {
      return moment(value, 'HH:mm:ss').format('HH:mm')
    }
    return moment(value, 'HH:mm:ss').format('hh:mm a')
  }
})

Vue.filter('fromShortDate', function (value, format = 'DD MMM YYYY') {
  if (!value) {
    return 'n/d';
  }
  return moment(value, 'YYYY-MM-DD').format(format);
})

Vue.filter('date', function (value, format = 'DD MMM YYYY') {
  return moment(value).format(format);
})

Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
  if (!showYear) {
    return regx.exec(val)[1];
  } else {
    return regx.exec(val)[1] + ' ' + regx.exec(val)[2];
  }

})

Vue.filter('csv', function (value) {
  return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
  return value.replace(/<\/?[^>]+(>|$)/g, "")
})

Vue.filter('k_formatter', function (num) {
  return num > 999 ? (num / 1000).toFixed(1) + 'k' : num
})

Vue.filter('ptoStatus', function (value) {
  return vueInstance.$t(`status.${value}`);
});

Vue.filter('role', function (value) {
  return vueInstance.$t(`roles.${value}`);
});

Vue.filter('currency', function (value) {
  if (!value) {
    return '';
  }
  switch (value.toUpperCase()) {
    case 'EURO':
      return '€';
    case 'ALBANIAN_LEK':
      return 'Lek';
    case 'USD':
      return '$';
  }
  return '';
});

Vue.filter('maintenanceType', function (value) {
  if (!value) {
    return '';
  }
  return vueInstance.$t(`maintenanceTypes.${value}`);
});
